var _Loader;
import { Loader } from "@crehana/compass.ui";
import { jsx as _jsx } from "react/jsx-runtime";
var CurrencyLoader = function CurrencyLoader() {
  return /*#__PURE__*/_jsx("div", {
    className: "tw-rounded-0.4 tw-h-5.6 tw-flex tw-items-center tw-justify-center tw-bg-neutral-light-400 dark:tw-bg-neutral-dark-600",
    style: {
      width: 260
    },
    children: _Loader || (_Loader = /*#__PURE__*/_jsx(Loader, {}))
  });
};
export default CurrencyLoader;